function queryString (search) {
  const query = {}
  if (search) {
    const params = search.substring(1).split('&')
    params.forEach(item => {
      const kv = item.split('=')
      if (kv[1]) {
        query[kv[0]] = decodeURIComponent(kv[1])
      }
    })
  }
  return query
}

const params = queryString(location.search)

let _index = 1000

let _fakeInvoke = (eventName, cb1, cb2) => {
  // ignore the second callback for now, hasn't decided how to commonlize this process
  console.log(eventName)

  if (cb2) {
    console.log(cb2)
  }

  if (eventName === 'stopRecord') {
    setTimeout(() => {
      cb1('uploadFile')
    }, 100)
    setTimeout(() => {
      cb2(JSON.stringify({
        status: '-11'
      }))
    }, 500)
  } else {
    if (typeof cb1 === 'function') {
      setTimeout(() => cb1(null), 100)
    } else {
      console.log(cb1)
    }
  }
}

const CALLBACK_FUNCS = [
  'nativeMinimize',
  'onActive',
  'onSuspend'
]

let isCallbackFunction = function (eventName) {
  return CALLBACK_FUNCS.indexOf(eventName) !== -1
}

let _key = (fn, event) => {
  let key = '_cb' + _index
  _index = _index + 1

  window[key] = function () {
    try {
      if (typeof fn === 'function') {
        fn.apply(window, arguments)
      }
      if (!isCallbackFunction(event)) {
        delete window[key]
      }
    } catch (e) {
      // should exception to track server
      console.log(e)
    }

    return 'success'
  }

  return key
}

export const NativeInterface = {
  invoke: function (event, cb1, cb2) {
    let args = [].slice.call(arguments, 1)
    let _len = args.length
    for (let i = 0; i < _len; i++) {
      if (typeof args[i] === 'function') {
        args[i] = _key(args[i], event)
      }
    }

    try {
      if (params.debug === 'true') {
        _fakeInvoke(event, cb1, cb2)
      } else if (/iP(ad|hone|od)/.test(navigator.userAgent)) {
        if (params.appVersion >= '3.1' || params.appId === 'lingocc') {
          if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.LLSiOS) {
            window.webkit.messageHandlers.LLSiOS.postMessage({
              eventName: event,
              args: args
            })
          } else {
            _fakeInvoke(event, cb1, cb2)
          }
        } else {
          // old ios invoking logic
          const urlScheme = 'lls://' + event + '/' + args.join('/')
          window.location = urlScheme
        }
      } else {
        if (window.LLSAndroid) {
          if (_len === 3) {
            window.LLSAndroid.invoke(event, args[0], args[1], args[2])
          } else if (_len === 2) {
            window.LLSAndroid.invoke(event, args[0], args[1])
          } else {
            window.LLSAndroid.invoke(event, args[0])
          }
        }
      }
    } catch (e) {
      console.log('invoke error : ', e)
    }
  }
}

export default {
  install (Vue, options = {}) {
    Vue.prototype.$nativeAPI = NativeInterface
  }
}



// WEBPACK FOOTER //
// ./src/plugins/NativeInterface.js